<script setup>
defineProps({
  text: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <div :class="$style.block">
    <span><slot>{{ text }}</slot></span>
  </div>
</template>

<style module>
.block {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 10rem;
  color: var(--color-text-muted);
  text-align: center;
}
</style>
